import React, { Component } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
} from "ui-kit-ck-consultant";

import { getReparableLabelsList } from "./TableReparable";
import { getUnreparableLabelsList } from "./TableUnreparable";
import { formatStat } from "./statFormat";

const toNumber = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") return isNaN(value) ? null : value;
  const cleaned = String(value)
    .replace(/ /g, "")
    .replace(/\s/g, "")
    .replace(/[^\d.,-]/g, "")
    .replace(",", ".");
  if (cleaned === "" || cleaned === "-") return null;
  const n = parseFloat(cleaned);
  return isNaN(n) ? null : n;
};

const compareValues = (a, b) => {
  const aNull = a == null || a === "";
  const bNull = b == null || b === "";
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  const aNum = toNumber(a);
  const bNum = toNumber(b);
  if (aNum != null && bNum != null) return aNum - bNum;
  return String(a).localeCompare(String(b), "fr", { sensitivity: "base" });
};

const SortIndicator = ({ direction }) => (
  <span style={{ marginLeft: 4, fontSize: 10, opacity: direction ? 1 : 0.3 }}>
    {direction === "desc" ? "▼" : "▲"}
  </span>
);

export default class TableByAgency extends Component {
  state = {
    mode: "R",
    sort: { R: null, NR: null },
  };

  handleSort = (datasetKey, key) => {
    this.setState((prev) => {
      const current = prev.sort[datasetKey];
      let next;
      if (!current || current.key !== key) {
        next = { key, direction: "asc" };
      } else if (current.direction === "asc") {
        next = { key, direction: "desc" };
      } else {
        next = null;
      }
      return { sort: { ...prev.sort, [datasetKey]: next } };
    });
  };

  renderTable(labels, datasetKey) {
    const agencies = (this.props.data || []).filter((agency) => {
      const row =
        agency.dataGeneral &&
        agency.dataGeneral[datasetKey] &&
        agency.dataGeneral[datasetKey][1];
      return row && Number(row.nbFolders) > 0;
    });

    const sort = this.state.sort[datasetKey];
    const getAgencyValue = (agency, labelId) => {
      const row =
        agency.dataGeneral &&
        agency.dataGeneral[datasetKey] &&
        agency.dataGeneral[datasetKey][1];
      return row ? row[labelId] : null;
    };

    let sortedLabels = labels;
    if (sort) {
      if (sort.key === "__label") {
        sortedLabels = [...labels].sort((la, lb) => {
          const cmp = compareValues(la.name, lb.name);
          return sort.direction === "desc" ? -cmp : cmp;
        });
      } else {
        const agency = agencies.find((a) => a.id === sort.key);
        if (agency) {
          sortedLabels = [...labels].sort((la, lb) => {
            const cmp = compareValues(
              getAgencyValue(agency, la.id),
              getAgencyValue(agency, lb.id)
            );
            return sort.direction === "desc" ? -cmp : cmp;
          });
        }
      }
    }

    const headerStyle = { cursor: "pointer", userSelect: "none" };
    const dirFor = (key) => (sort && sort.key === key ? sort.direction : null);

    return (
      <FadeIn className={"overflow-x-auto"}>
        <Table>
          <Thead>
            <Tr>
              <Th
                style={headerStyle}
                onClick={() => this.handleSort(datasetKey, "__label")}
              >
                Indicateur
                <SortIndicator direction={dirFor("__label")} />
              </Th>
              {agencies.map((a) => (
                <Th
                  key={a.id}
                  style={headerStyle}
                  onClick={() => this.handleSort(datasetKey, a.id)}
                >
                  {a.name}
                  <SortIndicator direction={dirFor(a.id)} />
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {sortedLabels.map((label) => (
              <Tr key={label.id}>
                <Th>{label.name}</Th>
                {agencies.map((a) => {
                  const row =
                    a.dataGeneral &&
                    a.dataGeneral[datasetKey] &&
                    a.dataGeneral[datasetKey][1]
                      ? a.dataGeneral[datasetKey][1]
                      : {};
                  return (
                    <Td key={a.id}>
                      {row[label.id] != null
                        ? formatStat(row[label.id], label.isCount)
                        : ""}
                    </Td>
                  );
                })}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </FadeIn>
    );
  }

  render() {
    const reparableLabels = getReparableLabelsList();
    const unreparableLabels = getUnreparableLabelsList();
    return (
      <TabsCustom>
        <TabsCustomHeader noCard>
          <TabsCustomMenu
            noCard
            title="Réparables"
            active={this.state.mode === "R"}
            onClick={() => this.setState({ mode: "R" })}
          />
          <TabsCustomMenu
            noCard
            title="Non Réparables"
            active={this.state.mode === "NR"}
            onClick={() => this.setState({ mode: "NR" })}
          />
        </TabsCustomHeader>
        <TabsCustomBody noCard>
          <TabsCustomItem active={this.state.mode === "R"}>
            {this.renderTable(reparableLabels, "R")}
          </TabsCustomItem>
          <TabsCustomItem active={this.state.mode === "NR"}>
            {this.renderTable(unreparableLabels, "NR")}
          </TabsCustomItem>
        </TabsCustomBody>
      </TabsCustom>
    );
  }
}
